import {makeEnumTypeGuard} from '../../../../libs/shared/helpers/src/typescript/enumHelpers';
import {ActionWithPayload} from '../../../helpers/reduxHelpers';
import {AppAction} from '../../appActions';

interface ChatPrecog {
  conversationId: number;
}

export enum ChatPrecogActionsEnum {
  CHAT_PRECOG_UPDATED = '@@data/chatPrecogs/PRECOG_UPDATED',
  CHAT_PRECOG_DELETED = '@@data/chatPrecogs/PRECOG_DELETED',
}

export function updateChatPrecog(conversationId: number): AppAction {
  return {
    type: ChatPrecogActionsEnum.CHAT_PRECOG_UPDATED,
    payload: {conversationId},
  };
}

export function deleteChatPrecog(conversationId: number): AppAction {
  return {
    type: ChatPrecogActionsEnum.CHAT_PRECOG_DELETED,
    payload: {conversationId},
  };
}

export interface ChatPrecogUpdatedAction extends ActionWithPayload<ChatPrecog> {
  type: ChatPrecogActionsEnum.CHAT_PRECOG_UPDATED;
}

export interface ChatPrecogDeletedAction extends ActionWithPayload<ChatPrecog> {
  type: ChatPrecogActionsEnum.CHAT_PRECOG_DELETED;
}

export type ChatPrecogAction = ChatPrecogUpdatedAction | ChatPrecogDeletedAction;

const isChatPrecogActionType = makeEnumTypeGuard(ChatPrecogActionsEnum);

export function isChatPrecogAction(action: AppAction) {
  return isChatPrecogActionType(action.type);
}
